<div class="modal-card card">
  <div class="card-header">
    <div class="row align-items-center">
      <div class="col">
        <h3 class="card-header-title"> {{ 'SEARCH_SETTINGS_MODAL.TITLE' | translate }}</h3>
      </div>
      <div class="col-auto">
        <button type="button" class="close" data-dismiss="modal" (click)="emitDismiss.emit()">×</button>
      </div>
    </div>
  </div>

  <div class="card-body modal-card-body-height">
    <div class="form-row justify-content-center">
      <div class="form-group-sm col-lg-4 col-md-5">
        <div class="d-flex align-items-center">
          <input
            id="enableLimitOfOffers"
            class="w-20 h-20 mr-3"
            type="checkbox"
            [(ngModel)]="enableLimitOfOffers">
          <label for="enableLimitOfOffers" class="mb-0">
            {{ 'SEARCH_SETTINGS_MODAL.ENABLE_LIMIT_OF_OFFERS.LABEL' | translate }}
          </label>
        </div>
      </div>
    </div>

    <div class="form-row justify-content-center" *ngIf="enableLimitOfOffers">
      <div class="form-group-sm col-lg-4 col-md-5">
        <label for="maxOffersPerCabin" class="d-flex align-items-center gap-10">
          {{ 'SEARCH_SETTINGS_MODAL.MAX_OFFERS_PER_CABIN.LABEL' | translate }}
          <ng-container [ngTemplateOutlet]="helpIcon"
                        [ngTemplateOutletContext]="{popoverText: 'SEARCH_SETTINGS_MODAL.MAX_OFFERS_PER_CABIN.HINT' | translate, btnKey: 'enableLimitOfOffers'}">
          </ng-container>
        </label>
        <input
          id="maxOffersPerCabin"
          type="number"
          class="form-control"
          [(ngModel)]="maxOffersPerCabin">
      </div>
    </div>

    <div class="form-row justify-content-center">
      <div class="form-group-sm col-lg-4 col-md-5">
        <label for="preferredStopsDuringFlight">
          {{ 'SEARCH_SETTINGS_MODAL.PREFERRED_STOPS_DURING_FLIGHT.LABEL' | translate }}
        </label>
        <select
          id="preferredStopsDuringFlight"
          class="form-control"
          [(ngModel)]="stopsAmount"
          (ngModelChange)="stopsAmount = $event ? Number($event) : null">
          <option value="0">{{ 'SEARCH_SETTINGS_MODAL.PREFERRED_STOPS_DURING_FLIGHT.OPTIONS.0' | translate }}</option>
          <option value="1">{{ 'SEARCH_SETTINGS_MODAL.PREFERRED_STOPS_DURING_FLIGHT.OPTIONS.1' | translate }}</option>
          <option value="10">{{ 'SEARCH_SETTINGS_MODAL.PREFERRED_STOPS_DURING_FLIGHT.OPTIONS.10' | translate }}</option>
        </select>
      </div>
    </div>

    <div class="form-row justify-content-center">
      <div class="form-group-sm col-lg-4 col-md-5">
        <label for="searchMode" class="d-flex align-items-center gap-10">
          {{ 'SEARCH_SETTINGS_MODAL.SEARCH_MODE.LABEL' | translate }}
          <ng-container [ngTemplateOutlet]="helpIcon"
                        [ngTemplateOutletContext]="{popoverText: searchModePopoverText, btnKey: 'searchMode'}">
          </ng-container>
        </label>
        <select
          id="searchMode"
          class="form-control"
          [(ngModel)]="searchMode">
          <option value=""> {{ 'SEARCH_SETTINGS_MODAL.SEARCH_MODE.OPTIONS.ALL' | translate }}</option>
          <option *ngFor="let mode of searchModes | pairs" [value]="mode[0]">{{mode[1]}}</option>
        </select>
      </div>
    </div>

    <div class="form-row justify-content-center">
      <div class="form-group-sm col-lg-4 col-md-5">
        <label for="requestTimeout" class="d-flex align-items-center gap-10">
          {{ 'SEARCH_SETTINGS_MODAL.REQUEST_TIMEOUT.LABEL' | translate }}
          <ng-container [ngTemplateOutlet]="helpIcon"
                        [ngTemplateOutletContext]="{popoverText: 'SEARCH_SETTINGS_MODAL.REQUEST_TIMEOUT.HINT' | translate, btnKey: 'requestTimeout'}">
          </ng-container>
        </label>
        <input
          id="requestTimeout"
          type="number"
          class="form-control"
          [(ngModel)]="requestTimeout">
      </div>
    </div>

    <div class="form-row justify-content-center">
      <div class="form-group-sm col-lg-4 col-md-5">
        <div class="d-flex align-items-center">
          <input
            id="avoidDisclosures"
            class="w-20 h-20 mr-3"
            type="checkbox"
            [(ngModel)]="avoidDisclosures">
          <label for="avoidDisclosures" class="d-flex align-items-center gap-10 mb-0">
            {{ 'SEARCH_SETTINGS_MODAL.AVOID_DISCLOSURES.LABEL' | translate }}
            <ng-container [ngTemplateOutlet]="helpIcon"
                          [ngTemplateOutletContext]="{popoverText: 'SEARCH_SETTINGS_MODAL.AVOID_DISCLOSURES.HINT' | translate, btnKey: 'avoidDisclosures'}">
            </ng-container>
          </label>
        </div>
      </div>
    </div>
  </div>

  <div class="card-footer text-right">
    <span
      (click)="emitDismiss.emit()"
      class="btn btn-secondary mr-3"
    >{{ 'BUTTONS.CLOSE' | translate }}
    </span>
    <span
      (click)="saveSearchSettings(); emitClose.emit()"
      class="btn btn-primary"
    >{{ 'BUTTONS.SAVE' | translate }}
    </span>
  </div>
</div>

<ng-template #searchModePopoverText>
  <span>{{ 'SEARCH_SETTINGS_MODAL.SEARCH_MODE.POPOVER_TEXT.TITLE' | translate }}</span>
  <ul class="mb-0 pl-5">
    <li><b>cheapest_flights:</b> {{ 'SEARCH_SETTINGS_MODAL.SEARCH_MODE.POPOVER_TEXT.CHEAPEST_FLIGHTS' | translate }}</li>
    <li><b>cheapest_flights_per_cabin:</b> {{ 'SEARCH_SETTINGS_MODAL.SEARCH_MODE.POPOVER_TEXT.CHEAPEST_FLIGHTS_PER_CABIN' | translate }}</li>
    <li><b>combine_same_fares_only:</b> {{ 'SEARCH_SETTINGS_MODAL.SEARCH_MODE.POPOVER_TEXT.COMBINE_SAME_FARES_ONLY' | translate }}</li>
    <li><b>cheapest_fare_with_baggage_only:</b> {{ 'SEARCH_SETTINGS_MODAL.SEARCH_MODE.POPOVER_TEXT.CHEAPEST_FARE_WITH_BAGGAGE_ONLY' | translate }}</li>
  </ul>
  <span>{{ 'SEARCH_SETTINGS_MODAL.SEARCH_MODE.POPOVER_TEXT.DEFAULT_COMBINATION' | translate }}</span>
</ng-template>

<ng-template #helpIcon let-popoverText="popoverText" let-btnKey="btnKey">
  <span class="material-icons fs-16 black-color"
        (mouseenter)="updateButtonName(btnKey, 'help')"
        (mouseleave)="updateButtonName(btnKey, 'help_outline')"
        [ngbPopover]="popoverText"
        [triggers]="'hover'"
        container="body"
        popoverClass="help-popover"
        placement="right"
        #popover="ngbPopover">
    {{buttonName[btnKey]}}
  </span>
</ng-template>
